"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const core_1 = require("@material-ui/core");
const md_1 = require("react-icons/md");
const Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));
const lodash_1 = require("lodash");
const formik_1 = require("formik");
const useStyles = (0, core_1.makeStyles)((theme) => ({
    input: {
        padding: '12.5px 4px !important',
        backgroundColor: 'transparent',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    adornment: {
        height: '100%',
        marginLeft: '16px',
        marginTop: '0 !important',
        width: '24px',
    },
    icon: {
        fill: '#24d654',
    },
}));
const RenderAutocompleteField = (props) => {
    const { field: { value, name, onChange }, form: { touched, errors, setFieldValue, submitCount, values, setFieldTouched }, label, placeholder, options, single, onValueChange = () => undefined, onFilterChange = () => undefined, defaultValue, parentField, Icon, ...otherProps } = props;
    const classes = useStyles();
    const error = (0, formik_1.getIn)(errors, name);
    const touch = (0, formik_1.getIn)(touched, name);
    const autocompleteRef = (0, react_1.useRef)(null);
    const initialValue = (0, react_1.useRef)(value || defaultValue);
    const parentFieldRef = (0, react_1.useRef)(null);
    const displayErrors = (touch || submitCount > 0) && !!error;
    const textChange = (0, react_1.useCallback)((0, lodash_1.throttle)((event) => onFilterChange(event.target.value), 500), []);
    (0, react_1.useEffect)(() => {
        if (value) {
            if (single) {
                setFieldValue(name, value.value);
            }
            else {
                setFieldValue(name, value.map((item) => item.value));
            }
        }
    }, []);
    if (parentField) {
        (0, react_1.useEffect)(() => {
            if (parentFieldRef.current && parentFieldRef.current !== values[parentField]) {
                const clearBtn = autocompleteRef.current.querySelectorAll('button[title="Clear"]')[0];
                if (clearBtn) {
                    clearBtn.click();
                }
            }
            parentFieldRef.current = values[parentField];
        }, [values[parentField]]);
    }
    const onAutocompleteChange = (event, newInputValue) => {
        if (!newInputValue) {
            return;
        }
        if (single) {
            setFieldValue(name, newInputValue.value);
        }
        else {
            if (newInputValue.length === 0) {
                setFieldValue(name, []);
            }
            else {
                setFieldValue(name, newInputValue.map((item) => item.value));
            }
        }
        onChange(event);
        onValueChange(event, newInputValue);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "mb-1.5" },
            react_1.default.createElement(core_1.InputLabel, null, label)),
        react_1.default.createElement(Autocomplete_1.default, { ref: autocompleteRef, classes: { input: classes.input }, options: options, onChange: onAutocompleteChange, multiple: !single, defaultValue: initialValue.current, getOptionLabel: (option) => option.label, popupIcon: react_1.default.createElement(md_1.MdExpandMore, null), getOptionSelected: (option, value) => {
                return value.value === option.value;
            }, onFocus: () => setFieldTouched(name, true), renderInput: (params) => (react_1.default.createElement(core_1.TextField, { ...params, variant: "filled", placeholder: placeholder, error: touch && !!error, fullWidth: true, onChange: textChange, InputProps: {
                    ...params.InputProps,
                    startAdornment: (react_1.default.createElement(react_1.default.Fragment, null,
                        Icon ? (react_1.default.createElement(core_1.InputAdornment, { className: classes.adornment, position: "start" },
                            react_1.default.createElement(Icon, { iconStyle: classes.icon }))) : null,
                        params.InputProps.startAdornment)),
                } })), ...otherProps }),
        displayErrors && (react_1.default.createElement(core_1.Typography, { variant: "body2", component: "p", color: "error", ...otherProps }, error))));
};
RenderAutocompleteField.defaultProps = {
    label: '',
};
RenderAutocompleteField.propTypes = {
    field: prop_types_1.default.any.isRequired,
    form: prop_types_1.default.any.isRequired,
    label: prop_types_1.default.string,
    placeholder: prop_types_1.default.string,
    single: prop_types_1.default.bool,
    options: prop_types_1.default.array.isRequired,
    onValueChange: prop_types_1.default.func,
    onFilterChange: prop_types_1.default.func,
    defaultValue: prop_types_1.default.any,
    parentField: prop_types_1.default.string,
    Icon: prop_types_1.default.any,
};
exports.default = RenderAutocompleteField;
